import { useCallback, useEffect, useState } from "react";
import { apiRequest, isAuthenticated, logout } from "../api";

// The signed-in marketplace member. `user` is undefined while loading, null when signed out, and
// otherwise { id, email, full_name, role: "buyer" | "seller" | null, is_staff, ...profile }.
// (role is null for admin accounts, which have no marketplace profile.)
export default function useCoWorkUser() {
  const [user, setUser] = useState(undefined);

  const refresh = useCallback(async () => {
    if (!isAuthenticated()) {
      setUser(null);
      return null;
    }
    const { ok, data } = await apiRequest("/core/cowork/me/", { auth: true });
    if (!ok) {
      logout();
      setUser(null);
      return null;
    }
    setUser(data);
    return data;
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signOut = useCallback(() => {
    logout();
    setUser(null);
  }, []);

  return { user, setUser, refresh, signOut };
}
